import React from 'react';

import { ButtonLink, CloseableContent, Table, USER_PERMISSIONS } from 'dyl-components';

import { Dropdown, Popup, Ref, Icon } from 'semantic-ui-react';
import CustomFieldGroupForm from 'shared/forms/CustomFieldGroupForm';
import RestrictedView from 'shared/RestrictedView';

const AddGroupItemSection = ({
    group_id,
    refresh,
    groupWhereASubgroupIsToBeCreated,
    onOpenAddGroupForm,
    onCloseAddGroupForm,
    isAddGroupFormModified,
    onModify,

    onOpenAddFieldModal,
    disabled
}) => {
    const addGroupFormRef = React.createRef();
    return (
        <Table.CollapsibleRowContent>
            <Table.Cell colSpan={6}>
                <Popup
                    content={(
                        <CloseableContent onClose={onCloseAddGroupForm}>
                            <CustomFieldGroupForm
                                parent_group={group_id}
                                refresh={refresh}
                                onModify={onModify}
                                onClose={onCloseAddGroupForm}
                                isSubgroup
                            />
                        </CloseableContent>
                    )}
                    open={groupWhereASubgroupIsToBeCreated === group_id}
                    closeOnDocumentClick={!isAddGroupFormModified}
                    onClose={onCloseAddGroupForm}
                    on='click'
                    position='bottom left'
                    context={addGroupFormRef}
                />
                <Ref innerRef={addGroupFormRef}>
                    <Dropdown disabled={disabled} icon='' as={ButtonLink} noPadding trigger={<span><Icon name='plus circle' /> New Custom Subgroup or Field</span>}>
                        <Dropdown.Menu>
                            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.DATA_CUSTOMIZATION_ADD}>
                            <Dropdown.Item onClick={() => { onOpenAddGroupForm(group_id) }}>
                                <Icon className='fas fa-layer-plus' /> Add Custom Subgroup
                            </Dropdown.Item>
                            </RestrictedView>
                            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.DATA_CUSTOMIZATION_ADD}>
                            <Dropdown.Item onClick={() => { onOpenAddFieldModal(group_id) }}>
                                <Icon className='fas fa-pen-field' /> Add Custom Field
                            </Dropdown.Item>
                            </RestrictedView>
                        </Dropdown.Menu>
                    </Dropdown>
                </Ref>
            </Table.Cell>
        </Table.CollapsibleRowContent>
    );
}

export default AddGroupItemSection;
